angular.module('lead')
    .controller('LeadShowModalController', function ($scope, $uibModalInstance, $filter, data, toastr, modals, ClientFinderService, ClientLead, Lead, TaskService, LeadActivityService, LeadService, FileAssociation, FileAssociationService, Document, Principal) {
        this.LeadService = LeadService;
        this.LeadActivityService = LeadActivityService;
        this.item = data;

        this.$onInit = () => {
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);
            this.canViewSourceData = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_LEADS_ALL']);
            this.canViewTasks = Principal.hasAnyAuthority(['ROLE_TASKS']);
            this.canViewNotes = Principal.hasAnyAuthority(['ROLE_NOTES']);
            this.canReadLeadClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_READ', 'ROLE_CLIENTS_LEAD_READ']);
            this.canWriteLeadClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_WRITE', 'ROLE_CLIENTS_LEAD_WRITE']);
            this.canViewDocuments = this.canViewTasks || this.canViewNotes;
            this.canSendSMS = this.item.smsUnlocked && this.hasPhoneNumber();
            this.activitiesCount = this.item.activitiesCount || 0;
            if (this.canViewSourceData) {
                this.loadSourceSnapshots();
            }
            this.loadFiles();
            this.loadClientContacts();
            this.loadDocumentsCount();
            this.loadDuplicateSuggestion();
        }

        this.hasPhoneNumber = () => hasContactOfType(this.item.client, 'PHONE') || ![null, ''].includes(this.item.sourcePhone);

        this.hasSourceData = () => !!(
            this.item.sourceName
            || this.item.sourcePhone
            || this.item.sourceEmail
            || this.item.sourceRequest
            || this.item.sourceMessage
            || this.item.sourceProject
            || this.item.sourcePropertyNumber
        );

        this.isSourceMessageLong = () => this.item.sourceMessage && this.item.sourceMessage.length > 260;

        this.hasMissingQualificationData = () => !this.item.acquisitionSource;
        this.hasMissingInterestData = () => !this.item.projects
            || this.item.projects.length === 0
            || !this.item.tags
            || this.item.tags.length === 0;
        this.canShowDuplicateSuggestion = () => this.item
            && this.item.id
            && ['WAIT', 'START'].includes(this.item.state?.status)
            && !!this.item.acquisitionDate;

        this.loadDuplicateSuggestion = () => {
            this.duplicateSuggestion = null;
            if (!this.canShowDuplicateSuggestion()) {
                return;
            }
            this.duplicateSuggestionPromise = Lead.duplicateSuggestion({id: this.item.id}).$promise
                .then(suggestion => this.duplicateSuggestion = suggestion && suggestion.lead && suggestion.lead.id ? suggestion : null);
        };

        this.openDuplicateModal = () => {
            if (!this.duplicateSuggestion) {
                return;
            }
            return modals.open('app/lead/duplicate-modal.html', 'LeadDuplicateController', {
                lead: angular.copy(this.item),
                suggestion: angular.copy(this.duplicateSuggestion)
            }, {size: 'md'}, '$ctrl').then(item => {
                toastr.success('Lead oznaczony jako DUBEL');
                this.item = item;
                this.$onInit();
            });
        };

        this.completeMissingData = () => modals.open('app/lead/manual-completion-modal.html', 'LeadManualCompletionController', angular.copy(this.item), {size: 'md'}, '$ctrl')
            .then(() => {
                toastr.success('Uzupełniono dane leada');
                return this.reload();
            });

        this.addTask = () => {
            if (!this.canViewTasks) {
                return;
            }
            let lead = this.item;
            if (!lead.client?.id) {
                return TaskService.addModal({
                    topic: lead.projects.map(p => p.name).join(', '),
                    description: "#" + lead.id + (lead.sourcePhone ? "\ntel. " + lead.sourcePhone + "\n" : ""),
                    private: false,
                    attendanceRequired: false
                })
            }
            let description = "#" + lead.id;
            let phones = contactValues(lead.client, 'PHONE').join(', ');
            if (phones != null) {
                description += "\n" + "tel. " + phones + "\n";
            }
            return TaskService.addModal({
                clients: [lead.client],
                topic: lead.projects.map(p => p.name).join(', '),
                description: description,
                private: false,
                attendanceRequired: false
            })
        }

        this.onLeadsLoaded = page => this.leadsCount = page ? page.fullListSize || 0 : 0
        this.onActivitiesLoaded = page => this.activitiesCount = page ? page.fullListSize || 0 : 0
        this.onDocumentsLoaded = page => this.documentsCount = page ? page.fullListSize || 0 : 0

        this.hasRelatedLeadsLookup = () => !!(
            (this.item.client && this.item.client.id)
            || trim(this.item.sourceEmail)
            || trim(this.item.sourcePhone)
        );

        this.loadSourceSnapshots = () => {
            if (!this.canViewSourceData || !this.item.id) {
                this.sourceSnapshots = [];
                return;
            }
            this.sourceSnapshotsPromise = Lead.sourceSnapshots({id: this.item.id}).$promise.then(items => {
                this.sourceSnapshots = (items || []).map(item => {
                    item.formattedPayloadJson = formatJson(item);
                    return item;
                });
            });
        }

        this.loadFiles = () => {
            if (!this.item.id) {
                this.filesPage = null;
                return;
            }
            this.filesPromise = FileAssociation.get({type: $filter("lowercase")("LEAD"), id: this.item.id}).$promise
                .then(response => this.filesPage = response);
        }

        this.loadDocumentsCount = () => {
            if (!this.canViewDocuments || !this.item.client || !this.item.client.id) {
                this.onDocumentsLoaded(emptyPage());
                return;
            }
            this.documentsCountPromise = Document.table({id: this.item.client.id, size: 1}).$promise
                .then(page => this.onDocumentsLoaded(page))
                .catch(() => this.onDocumentsLoaded(emptyPage()));
        }

        this.loadClientContacts = () => {
            if (!this.canReadLeadClients || !this.item.client || !this.item.client.id) {
                this.clientContacts = [];
                this.clientContactsLoaded = true;
                return;
            }
            this.clientContactsLoaded = false;
            this.clientContactsPromise = ClientLead.get({id: this.item.client.id}).$promise
                .then(client => this.clientContacts = client.contacts || [])
                .finally(() => this.clientContactsLoaded = true);
        }

        this.hasFiles = () => this.filesPage && this.filesPage.list && this.filesPage.list.length > 0;

        this.unbindFile = fileAssociation => FileAssociationService.unbind(fileAssociation, {type: "LEAD", id: this.item.id});

        this.hasMissingSourceContactInClient = () => this.clientContactsLoaded && hasMissingSourceContactInClient(this.item, this.clientContacts);
        this.hasMissingSourcePhoneInClient = () => this.clientContactsLoaded && canAddSourcePhone(this.item, this.item.client, this.clientContacts);
        this.hasMissingSourceEmailInClient = () => this.clientContactsLoaded && canAddSourceEmail(this.item, this.item.client, this.clientContacts);
        this.hasDifferentSourceNameInClient = () => hasDifferentSourceNameInClient(this.item);
        this.hasSourceSyncData = () => this.item.client && this.hasMissingSourceContactInClient();

        this.editClientWithSourceData = () => {
            if (!this.item.client || !this.hasSourceSyncData() || !this.canWriteLeadClients) {
                return;
            }
            return ClientLead.get({id: this.item.client.id}).$promise
                .then(client => ClientFinderService.edit(client, {
                    sourceSync: buildSourceSyncOptions(this.item),
                    beforeOpen: editedClient => applySourceDefaultsToClient(editedClient, this.item)
                }))
                .then(client => {
                    this.item.client = mapClientToLeadClient(client);
                    this.loadClientContacts();
                });
        };

        this.close = () => $uibModalInstance.dismiss('Canceled');

        $scope.$on('client.updated', () => Lead.get({id: data.id}).$promise.then((entity) => {
            this.item.client = entity.client;
            this.loadClientContacts();
        }));
        $scope.$on('lead.updated', () => this.reload());
        $scope.$on('lead.deleted', () => this.close());
        $scope.$on('lead.activity.updated', () => this.reload());
        $scope.$on('task.updated', () => this.loadDocumentsCount());
        $scope.$on('task.deleted', () => this.loadDocumentsCount());
        $scope.$on('note.updated', () => this.loadDocumentsCount());
        $scope.$on('note.deleted', () => this.loadDocumentsCount());
        $scope.$on('file.saved', () => this.loadFiles());

        this.reload = () => Lead.get({id: data.id}).$promise.then((entity) => {
            this.item = entity
            this.$onInit()
        })

        function formatJson(snapshot) {
            const value = snapshot && snapshot.payloadJson;
            if (!value) {
                return "";
            }
            try {
                const data = JSON.parse(value);
                if (angular.isObject(data) && data.id == null && snapshot.externalId != null) {
                    data.id = snapshot.externalId;
                }
                return JSON.stringify(data, null, 2);
            } catch (e) {
                return value;
            }
        }

        function emptyPage() {
            return {
                list: [],
                fullListSize: 0,
                objectsPerPage: 0,
                pageNumber: 1
            };
        }

        function hasContactOfType(client, type) {
            return contactValues(client, type).length > 0;
        }

        function contactValues(client, type) {
            return ((client && client.contacts) || [])
                .filter(contact => contact && contact.type === type && trim(contact.value))
                .map(contact => trim(contact.value));
        }

        function hasMissingSourceContactInClient(lead, contacts) {
            const client = lead && lead.client;
            if (!client) {
                return false;
            }
            return canAddSourcePhone(lead, client, contacts) || canAddSourceEmail(lead, client, contacts);
        }

        function applySourceDefaultsToClient(client, lead) {
            if (!client || !lead) {
                return;
            }
            client.contacts = client.contacts || [];
            if (canAddSourcePhone(lead, client, client.contacts)) {
                client.contacts.push({type: 'PHONE', value: trim(lead.sourcePhone), active: true, defaults: false});
            }
            if (canAddSourceEmail(lead, client, client.contacts)) {
                client.contacts.push({type: 'EMAIL', value: trim(lead.sourceEmail), active: true, defaults: false});
            }
            if (!trim(client.fullName) && trim(lead.sourceName)) {
                client.fullName = trim(lead.sourceName);
            }
        }

        function buildSourceSyncOptions(lead) {
            return {
                sourceName: trim(lead.sourceName),
                clientName: trim(lead.client && lead.client.fullName),
                nameDifferent: hasDifferentSourceNameInClient(lead)
            };
        }

        function canAddSourcePhone(lead, client, contacts) {
            const sourcePhone = phoneKeys(lead.sourcePhone);
            if (!sourcePhone || !client) {
                return false;
            }
            return !(contacts || []).some(contact => contact && contact.type === 'PHONE' && hasAnyPhoneMatch(sourcePhone, [contact.value]));
        }

        function canAddSourceEmail(lead, client, contacts) {
            const sourceEmail = trim(lead.sourceEmail).toLowerCase();
            if (!sourceEmail || !client) {
                return false;
            }
            return !(contacts || []).some(contact => contact && contact.type === 'EMAIL' && trim(contact.value).toLowerCase() === sourceEmail);
        }

        function hasDifferentSourceNameInClient(lead) {
            const sourceName = trim(lead && lead.sourceName);
            const clientName = trim(lead && lead.client && lead.client.fullName);
            return !!sourceName && !!clientName && normalizeName(sourceName) !== normalizeName(clientName);
        }

        function normalizeName(value) {
            return trim(value).replace(/\s+/g, ' ').toLowerCase();
        }

        function mapClientToLeadClient(client) {
            return {
                id: client.id,
                fullName: client.fullName,
                contacts: client.contacts,
                managerUsers: client.managerUsers,
                leadOnly: client.leadOnly,
                type: client.type,
                nip: client.nip,
                address: client.address,
                postcode: client.postcode,
                city: client.city
            };
        }

        function hasAnyPhoneMatch(sourceKeys, values) {
            return (values || []).some(value => {
                const keys = phoneKeys(value);
                return keys && sourceKeys.some(key => keys.indexOf(key) >= 0);
            });
        }

        function phoneKeys(value) {
            const digits = trim(value).replace(/\D/g, '');
            if (!digits) {
                return null;
            }
            const keys = [digits];
            if (digits.length === 11 && digits.indexOf('48') === 0) {
                keys.push(digits.substring(2));
            }
            if (digits.length === 9) {
                keys.push('48' + digits);
            }
            return keys;
        }

        function trim(value) {
            return value == null ? '' : String(value).trim();
        }
    })
    .controller('LeadManualCompletionController', function ($rootScope, $uibModalInstance, data, Lead) {
        this.item = data;
        this.item.projects = this.item.projects || [];
        this.item.tags = this.item.tags || [];

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.isComplete = () => !!this.item.acquisitionSource
            && this.item.projects
            && this.item.projects.length > 0
            && this.item.tags
            && this.item.tags.length > 0;

        this.save = form => {
            if (!this.isComplete()) {
                if (form) {
                    form.$setSubmitted();
                }
                return;
            }
            return Lead.completeManualData({id: this.item.id}, {
                notes: this.item.notes,
                acquisitionSource: this.item.acquisitionSource,
                projects: this.item.projects,
                tags: this.item.tags
            }).$promise.then(result => {
                $rootScope.$broadcast('lead.updated');
                $uibModalInstance.close(result);
            });
        };

        function trim(value) {
            return value == null ? '' : String(value).trim();
        }
    })
    .controller('LeadDuplicateController', function ($rootScope, $uibModalInstance, data, Lead, LeadService) {
        this.LeadService = LeadService;
        this.lead = data.lead;
        this.duplicateLead = data.suggestion.lead;
        this.form = {
            duplicateLeadId: this.duplicateLead.id,
            state: data.suggestion.state || {status: 'OUT'},
            notes: data.suggestion.notes
        };

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.onStatusChanged = () => {
            if (this.form.state.status !== 'OUT') {
                delete this.form.state.outStage;
                delete this.form.state.outReason;
            }
        };
        this.isComplete = () => !!this.form.state
            && !!this.form.state.status
            && (this.form.state.status !== 'OUT' || (!!this.form.state.outStage && !!this.form.state.outReason));

        this.save = form => {
            if (!this.isComplete()) {
                if (form) {
                    form.$setSubmitted();
                }
                return;
            }
            return Lead.markDuplicate({id: this.lead.id}, this.form).$promise.then(result => {
                $rootScope.$broadcast('lead.updated');
                $uibModalInstance.close(result);
            });
        };
    })
